import authService from '@/services/auth'
import types from '../mutation-types'

const state = {
  isAuthenticated: !!localStorage.getItem('authToken'),
  authToken: localStorage.getItem('authToken'),
  currentUser: null
}

const getters = {
  authToken: state => {
    return state.authToken
  },
  isAuthenticated: state => {
    return state.isAuthenticated
  },
  hasRole: state => roles => {
    if (!state.currentUser || !state.currentUser.roles) return false
    let hasRole = false
    roles.forEach(role => {
      if (state.currentUser.roles.includes(role)) {
        hasRole = true
      }
    })
    return hasRole
  },
  currentUser: state => {
    return state.currentUser
  }
}

const actions = {
  acceptTermsConditions({ commit, state }, payload) {
    return authService
      .acceptTermsConditions(payload.accept)
      .then(() => {
        return authService.getCurrentUser()
      })
      .then(user => {
        return commit(types.USER_LOADED, user)
      })
      .catch(err => {
        throw new Error(err.bodyText)
      })
  },
  renewPassword({ commit, state }, payload) {
    return authService
      .renewPassword(payload.email)
      .then(() => {})
      .catch(err => {
        throw new Error(err.bodyText)
      })
  },
  checkAuth({ commit, state }, payload) {
    if (state.authToken) {
      return authService
        .getCurrentUser()
        .then(user => {
          commit(types.USER_LOADED, user)
        })
        .catch(err => {
          commit(types.AUTHENTICATE_FAILURE, err)
          throw new Error('Error when login', err)
        })
    } else {
      return Promise.resolve()
    }
  },
  login({ commit, state }, payload) {
    const email = payload.email
    const password = payload.password
    return authService
      .login(email, password)
      .then(token => {
        commit(types.AUTHENTICATE_SUCCESS, token)
      })
      .then(() => {
        return authService.getCurrentUser()
      })
      .then(user => {
        return commit(types.USER_LOADED, user)
      })
      .catch(err => {
        commit(types.AUTHENTICATE_FAILURE, err)
        throw new Error('Error when login')
      })
  },
  signUp({ commit, state }, payload) {
    return authService
      .signUp(payload)
      .then(() => {
        return authService.confirmEmail(payload.email)
      })
      .catch(err => {
        throw new Error(err.bodyText)
      })
  },
  logout({ commit, state }, payload) {
    commit(types.AUTHENTICATE_FAILURE, new Error('logout'))
  }
}

const mutations = {
  [types.AUTHENTICATE_SUCCESS](state, payload) {
    localStorage.setItem('authToken', payload)
    state.authToken = payload
    state.isAuthenticated = true
  },
  [types.AUTHENTICATE_FAILURE](state, err) {
    localStorage.removeItem('authToken')
    localStorage.removeItem('currentUser')
    state.isAuthenticated = false
    state.currentUser = null
    state.authToken = null
  },
  [types.USER_LOADED](state, user) {
    localStorage.setItem('currentUser', user)
    state.currentUser = user
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js